import taskGroupsCommitTypes from './commit-types';
import ReducerUtilities from '../../../shared/store/reducer-utilities';

const INITIAL_TASK_GROUPS_STATE = {
  isAddingTaskGroup: false,
  isLoading: [],
  list: null,
  selectedGuid: null,
  taskGroupParentMap: {},
  taskGroupMap2: {}
};

function taskGroupsReducers(state = INITIAL_TASK_GROUPS_STATE, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case taskGroupsCommitTypes.PUSH_TASK_GROUP:
      return {
        ...state,
        list: [...state.list, action.taskGroup],
      };
    case taskGroupsCommitTypes.PUSH_TASK_GROUPS:
      return {
        ...state,
        list: action.taskGroups,
      };
    case taskGroupsCommitTypes.SET_TASK_GROUP_MAP:
      return {
        ...state,
        taskGroupMap: action.tasksMap,
      };

    case taskGroupsCommitTypes.SET_TASK_GROUP_MAP2:
      return {
        ...state,
        taskGroupMap2: action.tasksGroupMap,
      };

    case taskGroupsCommitTypes.REMOVE_TASK_GROUP:
      return {
        ...state,
        list: state.list.filter(tg => tg.taskGroupGuid !== action.taskGroupGuid)
      };
    case taskGroupsCommitTypes.REPLACE_TASK_GROUP:
      return {
        ...state,
        list: state.list.map(tg =>
          tg.taskGroupGuid === action.taskGroup.taskGroupGuid
            ? action.taskGroup
            : tg),
      };
    case taskGroupsCommitTypes.SET_IS_ADDING_TASK_GROUP:
      return {
        ...state,
        isAddingTaskGroup: action.isAddingTaskGroup,
      };
    case taskGroupsCommitTypes.SET_TASK_GROUPS_IS_LOADING:
      return {
        ...state,
        isLoading: ReducerUtilities.updateIsLoading(
          action.isLoading,
          state.isLoading,
        ),
      };
    case taskGroupsCommitTypes.RESET_TASK_GROUP_STATE:
      return { ...INITIAL_TASK_GROUPS_STATE };
    case taskGroupsCommitTypes.SET_SELECTED_TASK_GROUP_GUID:
      return {
        ...state,
        selectedGuid: action.selectedGuid,
      };
    default:
      return state;
  }
}

export default taskGroupsReducers;
